module.exports = __webpack_public_path__ + "img/reload.18fd2cb6.svg";